<template>
    <div
        class="map-panel"
        :class="[
            'map-align-' + align,
            {
                'map-dark': dark
            }
        ]"
        >
        <div class="map-panel-inner">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default
    {
        name: 'panel',
        props:
        {
            align:
            {
                type: String,
                default: 'left'
            },
            dark: Boolean,
        },
    }
</script>
